import { render } from "./InputCPF.vue?vue&type=template&id=b4b70f44"
import script from "./InputCPF.vue?vue&type=script&lang=js"
export * from "./InputCPF.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__